import type { TDictionaryItem, TUser } from '../../api/types'

const nonEmpty = (value: string | null | undefined): boolean =>
  (value ?? '').trim().length > 0

const hasDictionaryItems = (items?: TDictionaryItem[]): boolean =>
  Array.isArray(items) && items.some((row) => row.id > 0)

const hasValidAge = (age: number | null | undefined): boolean =>
  typeof age === 'number' && Number.isInteger(age) && age >= 14 && age <= 100

/**
 * Соответствие обязательным полям формы профиля (Zod).
 * Обязательные: аватар, фамилия, имя, статус, возраст (14–100 по данным API), «о себе» и обязательные словари.
 * Необязательные: отчество, регион, город, вид деятельности.
 */
export const isProfileComplete = (user: TUser): boolean =>
  nonEmpty(user.avatar) &&
  nonEmpty(user.lastname) &&
  nonEmpty(user.name) &&
  nonEmpty(user.status) &&
  hasValidAge(user.age) &&
  (nonEmpty(user.description) ||
    nonEmpty(user.full_description) ||
    nonEmpty(user.about)) &&
  hasDictionaryItems(user.competencies) &&
  hasDictionaryItems(user.resources) &&
  hasDictionaryItems(user.participation) &&
  hasDictionaryItems(user.improvements)
